"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTreeInteractor = void 0;
const operators_1 = require("rxjs/operators");
const core_1 = require("@veeam/core");
class DataTreeInteractor extends core_1.Interactor {
    constructor(model, asyncNodesModel, config) {
        super();
        this.model = model;
        this.asyncNodesModel = asyncNodesModel;
        this.config = config;
        this.fetchNodeSubsMap = new Map();
    }
    abortFetchNode(id) {
        const fetchNodeSubs = this.fetchNodeSubsMap.get(id);
        if (fetchNodeSubs) {
            fetchNodeSubs.unsubscribe();
            this.fetchNodeSubsMap.delete(id);
        }
    }
    removeAsyncNodeFromLoading(id) {
        this.asyncNodesModel.update((values) => {
            values.loadingIds = values.loadingIds.filter((loadingId) => loadingId !== id);
        });
    }
    removeAsyncNodeFromWarning(id) {
        this.asyncNodesModel.update((values) => {
            values.warningMap = values.warningMap.filter((warning) => warning[0] !== id);
        });
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions = this.model.fieldChanges('pagination').subscribe(() => {
                this.model.load();
            });
            this.subscriptions.add(this.model.fieldChanges('sorting').subscribe(() => {
                this.model.load();
            }));
            this.subscriptions.add(this.model.fieldChanges('filters').subscribe(() => {
                this.model.load();
            }));
            if (this.config.autoLoad) {
                yield this.model.load();
            }
        });
    }
    didSelectionChange(nextSelection) {
        this.model.update((prevValue) => {
            prevValue.selection = nextSelection;
        });
    }
    didCheckedChange(nextChecked) {
        this.model.update((prevValue) => {
            prevValue.checked = nextChecked;
        });
    }
    didExpandChange(nextExpanded) {
        this.model.update((prevValue) => {
            prevValue.expanded = nextExpanded;
        });
    }
    didToggleExpandNode(node, isExpanded) {
        if (node.isAsync()) {
            const { id } = node;
            if (isExpanded) {
                this.asyncNodesModel.update((values) => {
                    values.loadingIds = [...values.loadingIds, id];
                });
                this.fetchNodeSubsMap.set(id, this.model
                    .fetchNode(node)
                    .pipe((0, operators_1.finalize)(() => {
                    this.removeAsyncNodeFromLoading(id);
                    this.fetchNodeSubsMap.delete(id);
                }))
                    .subscribe(({ data }) => {
                    var _a, _b, _c;
                    const loadedNode = (_a = data.items) === null || _a === void 0 ? void 0 : _a[0];
                    if (loadedNode) {
                        this.model.updatedItemById(id, loadedNode);
                        (_c = (_b = this.config).onAsyncNodeLoad) === null || _c === void 0 ? void 0 : _c.call(_b, loadedNode);
                    }
                }, (error) => {
                    this.asyncNodesModel.update((values) => {
                        values.warningMap.push([id, error]);
                    });
                }));
            }
            else {
                this.abortFetchNode(id);
                this.removeAsyncNodeFromLoading(id);
                this.removeAsyncNodeFromWarning(id);
            }
        }
    }
    willDeactivate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this.subscriptions) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this.fetchNodeSubsMap.forEach((subs) => {
                subs.unsubscribe();
            });
            this.fetchNodeSubsMap.clear();
        });
    }
}
exports.DataTreeInteractor = DataTreeInteractor;
//# sourceMappingURL=DataTreeInteractor.js.map